import React from 'react'
import {compose, lifecycle} from 'recompose'
import _ from 'lodash'
import getUrl from "../../getUrl";
import CategoryHeader from '../../finwhale/common/category/header'
import CategoryText from "../../finwhale/common/category/text";
import CategoryTable from "../../finwhale/common/category/table";
import getImgUrl from "../../getImgUrl";
import CategoryNewList from '../../finwhale/common/category/new'

const BeltsRibbed = ({type18, loading18}) => (
  <div>
    <div style={{width: '80%', margin: '0 auto', fontSize: '18px'}}>

        <CategoryHeader
          name='catalogue_policlin__title'
          img={getImgUrl(`/media/static/cats/Belt_1__Finwhale.png`)}
          box='catalogue_policlin__box'
          settingsText='catalogue_policlin__settings'
          protectedText='catalogue_policlin__protected'
          checkedText='catalogue_policlin__checked'
        />

        <div>
          <CategoryTable
            install_axis={type18}
            loading={loading18}
          />
          <CategoryNewList type={18}/>
          <CategoryText
            advantages={'catalogue_policlin__additional_benefits'}
            characteristics={'catalogue_policlin__characteristics'}
          />
        </div>
    </div>
  </div>
)

const enhance = compose(
  lifecycle({
    state: {loading3: true, loading18: true},
    componentDidMount() {
      fetch(getUrl(`/cat/v1/item?type_id=18`)).then(data => {
        return data.json()
      }).then(listItems => {
        const type18 = _.get(listItems, 'data.data')
        this.setState({type18, loading18: false})
      }).catch(err => {
        console.log(err)
      })
    }
  }),
)

export default enhance(BeltsRibbed)




// WEBPACK FOOTER //
// ./src/pages/production/belts-ribbed.js